import { styled } from 'styled-components';
import { COLORS } from '@ydistri/theme';

export const TwoColumnContainer = styled.div<{ $displayBottomBorder?: boolean }>`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  align-items: start;
  border-bottom: ${p => (p.$displayBottomBorder ? `1px solid ${COLORS.BORDER}` : 'none')};
`;
